import React from "react";

/**
 * Single-pick "Activity + Event Attribute" picker, used for the reference
 * (Soll-Termin) date when its source is 'event_attribute' — a custom field
 * recorded on events of a given activity (e.g. "requested_delivery_date" on
 * an order-creation event), as opposed to an object attribute or the event's
 * own timestamp.
 */
const EventAttributeDateSourcePicker = ({
  value,
  onChange,
  activitiesForType,
  getAttributesForActivity,
  loading = false,
  activitiesLoading = false,
}) => {
  const activity = value?.activity || "";
  const attribute = value?.attribute || "";
  const attrs = activity ? getAttributesForActivity(activity) : [];

  return (
    <div className="space-y-2">
      <select
        value={activity}
        onChange={(e) => onChange({ activity: e.target.value, attribute: "" })}
        disabled={loading || activitiesLoading}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
      >
        <option value="">Aktivität wählen…</option>
        {activitiesForType.map((act) => (
          <option key={act} value={act}>{act}</option>
        ))}
      </select>
      <select
        value={attribute}
        onChange={(e) => onChange({ activity, attribute: e.target.value })}
        disabled={loading || !activity}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
      >
        {!activity ? (
          <option value="">Erst Aktivität wählen…</option>
        ) : attrs.length === 0 ? (
          <option value="">Keine Event-Attribute gefunden</option>
        ) : (
          <option value="">Event-Attribut wählen…</option>
        )}
        {attrs.map((attr) => (
          <option key={attr} value={attr}>{attr}</option>
        ))}
      </select>
    </div>
  );
};

export default EventAttributeDateSourcePicker;
